export default __webpack_public_path__ + "static/postgresql-714af8e44b9e8d40e8c2c94dc7e6c283.png";